import { PROVIDER_INFO } from "state/actions/provider";
import { PlaidInfo, TrustlyInfo } from "types";
import createReducer from "./createReducer";

export default createReducer<PlaidInfo | TrustlyInfo>({
  successType: PROVIDER_INFO,
});
